export const DEFAULT_ZOOM = 8;

export const MARKER_ZOOM = 12;